import { JOB_PLANTDATA_HISTORY_INTERVAL } from 'common/constants';
import { Logger } from 'common/logger';
import { checkWebsocketConnection } from 'common/saga-utils';
import { rematchStore } from 'models/rematchStore';

export const defaultData = {
    active_power: { value: null },
    capacity_factor: { value: null },
    power_sales_price: { value: null },
    historicalData: { values: [] },
    polling: null,
};

export const plantData = {
    name: 'plantData',
    state: { ...defaultData },

    reducers: {
        updateAll(_, payload) {
            Logger.debug('Plantdata.updateAll');
            return { ...payload };
        },
        loadMultiple(state, payload) {
            Logger.debug(`Plantdata.loadMultiple Bulk updating ${payload.length}`, payload);
            let newState = { ...state };
            payload.forEach((item) => {
                newState = { ...newState, ...item };
            });
            return newState;
        },
        addPerformanceMetrics(state, payload) {
            return {
                ...state,
                capacity_factor: payload.capacity_factor,
            };
        },
        loadPricing(state, payload) {
            Logger.debug('Plantdata.loadPricing', payload);
            return {
                ...state,
                ...payload,
            };
        },
        loadHistory(state, payload) {
            Logger.debug('Plantdata.loadHistory', payload);
            return {
                ...state,
                historicalData: payload,
            };
        },
        clearPolling(state) {
            if (state.polling) {
                clearInterval(state.polling);
                Logger.info('Polling stopped'); // Log when polling is stopped
            }
            return { ...state, polling: null };
        },
        setPolling(state, polling) {
            return { ...state, polling };
        },
    },

    effects: (dispatch) => ({
        async startHistoryJob() {
            Logger.info('Starting plantData.startHistoryJob');

            await checkWebsocketConnection();

            // Function to perform the history job
            const historyJob = () => {
                const { id } = rematchStore.getState().appData.selectedParkData;
                Logger.info('History data request for plant:', id);
                dispatch({
                    type: 'webSocket/requestPlantHistory',
                    payload: {
                        entityKey: id,
                        precision: 'minute',
                        count: 60 * 7,
                    },
                });
            };
            historyJob();

            // Start the polling
            const polling = setInterval(historyJob, JOB_PLANTDATA_HISTORY_INTERVAL);
            dispatch.plantData.setPolling(polling);
        },
        clearHistoryJobs() {
            Logger.info('Stopping history job');
            dispatch.plantData.clearPolling(); // Clear polling when this action is dispatched
        },
        getSelectedParkData() {
            // To select current park data from state
            return (state) => state.app.selectedParkData;
        },

        async reset() {
            Logger.info('Reset plantData');
            dispatch.plantData.updateAll(defaultData);
            dispatch.plantData.clearHistoryJobs();
            dispatch.plantData.startHistoryJob();
        },

        restartJob() {
            Logger.info('Restarted plantData');
        },
    }),
};

export default plantData;
